// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ZhAo","title":"Info_title__dzJ3e","selects":"Info_selects__3QrC1","requiredAsterisk":"Info_requiredAsterisk__3oMXx"};